<template>
  <div class="c-form__row">
    <div class="c-form__submit">
      <button @click="loginClicked" class="o-button o-button--wide">{{$t(i18n.label)}}</button>
    </div>
  </div>
</template>

<script>
  import {Utils} from "@bvm/core";

  const i18nBuilder = new Utils.I18n.I18nBuilder('confirm_login')
      .add('label');
  export const messageKeys = i18nBuilder.getKeys();

  export  default {
    name: "ConfirmLogin",
    data() {
      return {
        i18n: i18nBuilder.getData()
      }
    },
    methods: {
      loginClicked: function () {
        let token = this.getUrlParam('token');
        window.location.href = `/web/rest-profile/identity/token-login?token=${token}`;
      },
      getUrlParam: function getUrlParam(key) {
        return new URL(window.location.href).searchParams.get(key);
      }
    }
  }
</script>